import { DYNAMICFORMS_URL, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSDYNAMICFORMS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const  postDataForm =( async (formKey,data,PRJ_UID,returnJobId=false) =>  await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.AddFirst,
    method: "post",
   params:{
    formKey:formKey,
    PRJ_UID:PRJ_UID,
    returnJobId
    },
    data:data,
})

.then((respons) => (respons.data))
)


export const getFormInformationByReferenceId = (async ( ReferenceId,formKey ) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.ReferenceId,
    headers: { "Accept-Language": "en" },
    method: 'get',
    params:{
        ReferenceId:ReferenceId,
        formKey:formKey,
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)



export const getDataForPrint = ( Id , obj,data=null) => http({
    baseURL:DYNAMICFORMS_URL,

    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.printData,
    method: "post",
    params:{
        id:Id,
        useWarmSignature: true ,
        ...obj
    },
    data
    
}).then((res) => {
     
    return res.data
}).catch((err) => {

    return Promise.reject(err);
});


export const getFormInformationById = (async ( id,formKey ) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.id,
    headers: { "Accept-Language": "en" },
    method: 'get',
    params:{
        id:id,
        formKey:formKey,
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const  putInformationFormWorkflow =( async (referenceId,formKey,data) =>  await http({
    baseURL:DYNAMICFORMS_URL ,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.Workflow,
    method: 'put',
  

    params: {
        referenceId:referenceId,
        formKey:formKey
    },
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)
export const  putInformationForm =( async (id,formKey,data) =>  await http({
    baseURL:DYNAMICFORMS_URL ,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.data,
    method: 'put',
  

    params: {
        id:id,
        formKey:formKey
    },
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)